/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Delete Guarantor Refund Button
 */
import { Button, App } from 'antd';
import { ButtonProps } from 'antd/lib';

import useDeleteGuarantorRefund from 'hooks/accounts/mutate/useDeleteGuarantorRefund';
import { formatAmount } from 'utils/accounts/allAccounts';

type IProps = {
	data: Guarantor.IGuarantorResponse;
};

const DeleteGuarantorRefund: React.FC<IProps & ButtonProps> = ({ data, ...rest }) => {
	const { modal } = App.useApp();
	const { mutateAsync } = useDeleteGuarantorRefund();

	const refundAmount = data?.metadata?.refundAmount;

	const handleClick = () => {
		modal.confirm({
			title: 'Delete Refund',
			width: 560,
			closable: true,
			content: (
				<>
					{`Are you sure you want to permanently delete this recorded refund of ${formatAmount(refundAmount ?? 0)}?`}
					<br />
					<br />
					{'This action cannot be undone.'}
				</>
			),
			okText: 'Delete',
			okButtonProps: { danger: true },
			cancelText: 'Cancel',
			onOk: async () => {
				await mutateAsync({ guarantorId: data?.fhirResource?.id });
			},
		});
	};

	return (
		<Button danger onClick={handleClick} {...rest}>
			{'Delete'}
		</Button>
	);
};

export default DeleteGuarantorRefund;
